export default "__VITE_ASSET__CgAPSRGs__"